module.exports.tagsJson = [{
  type: 'tags',
  id: '40e64437-48fe-4acb-a614-0b146adad6f1',
  attributes: {
    value: 'Fashion',
  },
  selected: false,
}, {
  type: 'tags',
  id: 'b151e9a1-beae-498b-ae4a-6bb27e875288',
  attributes: {
    value: 'Beauty',
  },
  selected: false,
}, {
  type: 'tags',
  id: '9a5ddfc5-71d7-4857-b643-339e640939b2',
  attributes: {
    value: 'Home',
  },
  selected: false,
}, {
  type: 'tags',
  id: '6c793493-7161-47c7-99ec-f40c511f7ac2',
  attributes: {
    value: 'Mommy',
  },
  selected: false,
}, {
  type: 'tags',
  id: '791e6c3c-e781-451e-bd1d-bee00f96b1e5',
  attributes: {
    value: 'Food',
  },
  selected: false,
}, {
  type: 'tags',
  id: '983a7bb6-ce1e-4486-b310-f5c32929e2db',
  attributes: {
    value: 'Health',
  },
  selected: false,
}, {
  type: 'tags',
  id: '7c0f5cf7-5ed8-438d-8bc7-02b6ee49c9a9',
  attributes: {
    value: 'Vegan/vegeterian',
  },
  selected: false,
}, {
  type: 'tags',
  id: '1c42628e-44df-453b-9369-1897435c6489',
  attributes: {
    value: 'Pets',
  },
  selected: false,
}, {
  type: 'tags',
  id: 'a1c5f80b-b890-4ea1-8fe5-f2ad167c1ce5',
  attributes: {
    value: 'Lifestyle',
  },
  selected: false,
}, {
  type: 'tags',
  id: 'f07a4b4c-b0c4-4460-972d-8f0a2aabe444',
  attributes: {
    value: 'Sport',
  },
  selected: false,
}];



/** WEBPACK FOOTER **
 ** ./src/themes/theme/tags/mingoapp/tags.js
 **/